const initialState = {
	flujo: null,
	activo: false,
};

export function multicanalRdc(state = initialState, action) {
	switch (action.type) {
	case "RESET_FLUJO_MULTICANAL":
		return { ...initialState };
	case "SET_FLUJO_MULTICANAL":
		return {...state, flujo: action.flujo, activo: true };
	default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/gnp-multicanal/reducer.js